<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle
                :value="checked"
                :messages="messages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'calendar-facet-start-date';

export default {
    name: 'calendar-facet-start-date',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Don\'t show past events',
            value: '',
            checked: true,
            message: '',
            messages: {
                checked: 'Yes',
                unchecked: 'No',
            },
        };
    },

    methods: {
        onInput(isChecked) {
            if (isChecked) {
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, 'true');
            } else {
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, 'false');
            }

            this.checked = isChecked;
            this.onOptionChange(isChecked);
        },

        onSelectedElement() {
            this.checked = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) === 'true';
        },
    },
};
</script>
